import { Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import questionConfigs from 'modules/reviews/store/collections/questionConfigs'
import type Review from 'modules/reviews/store/models/v2/Review'

interface Props {
  review: Review
}

const PerformanceScoreToggle = ({ review }: Props) => {
  const onSubmit = async () => {
    await asyncAction(() =>
      review.update({
        setting: { include_review_scoring: !review.hasScoreQuestions },
      })
    )

    await asyncAction(() => questionConfigs.fetch({ data: { surveys_form_id: review.id } }))
  }

  return (
    <Card>
      <Card.Title
        action={
          <TogglerCheckbox
            value={review.hasScoreQuestions}
            onChange={onSubmit}
            disabled={!review.isDraft}
          />
        }
      >
        {i18n.t('surveys.review.questions.employee_metrics_toggle.title')}
      </Card.Title>
      <Card.Description>
        {i18n.t('surveys.review.questions.employee_metrics_toggle.description')}
      </Card.Description>
    </Card>
  )
}

export default observer(PerformanceScoreToggle)
